import { default as html2canvas, type Options } from 'html2canvas';

import { logger } from '@/components/SgwtBootstrap/logger.ts';

// copied from https://sgithub.fr.world.socgen/SGMARKETS-EXECUTION/fx/blob/9577036b3757edc5d740ff8c73d3a7c2cef98cea/fx-web/app/src/utils/screenshot.ts

export const takeScreenshotHOF = (html2canvasParam: typeof html2canvas, element: HTMLElement) => () => {
  const opts: Partial<Options> = {
    allowTaint: false,
    logging: import.meta.env.DEV,
    useCORS: true,
    ignoreElements: (htmlElement: Element) =>
      (htmlElement instanceof HTMLImageElement && htmlElement.src.toLowerCase().includes('piwik')) ||
      htmlElement.id === 'HelpRequestModal',
  };
  // eslint-disable-next-line no-console
  console.info('Will generate screenshot for help request');
  return html2canvasParam(element, opts)
    .then((canvas) => {
      // eslint-disable-next-line no-console
      console.info('Did generate screenshot');
      return canvas.toDataURL('image/png');
    })
    .catch((reason) => {
      logger.logError('Could not generate screenshot for help request {message_s}', reason.message);
      return undefined;
    });
};

let _takeScreenshot: () => Promise<string | undefined>;

export const takeScreenshot = () => {
  if (_takeScreenshot === undefined) {
    _takeScreenshot = takeScreenshotHOF(html2canvas, document.body);
  }

  return _takeScreenshot();
};

export interface ITakeOptions {
  element: HTMLElement;
  shouldIgnoreElement: (element: Element) => boolean;
}

export function take({ element, shouldIgnoreElement }: ITakeOptions): Promise<HTMLCanvasElement> {
  return html2canvas(element, {
    logging: true,
    ignoreElements: (htmlElement): boolean => {
      if (htmlElement instanceof HTMLImageElement && htmlElement.src.toLowerCase().includes('piwik')) {
        return true;
      }

      return shouldIgnoreElement(htmlElement);
    },
  });
}
